import { extendTheme } from "@chakra-ui/react";

import config from "./config";
import colors from "./colors";
import semanticTokens  from "./semanticTokens";
import styles from "./styles";
import fonts, { FontCss } from "./fonts";
import components from "./components";

export {
  FontCss
};

const theme = extendTheme({
  config,
  colors,
  fonts,
  styles,
  components,
  semanticTokens,
});

export default theme;

export const PANEL_SIZE = "26rem";
